
















































































































































































import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { SwStatusFlag } from '../sw-status-flag';
import { SwToggle } from '../sw-toggle';
import { SwTransitionExpand } from '../sw-transition';
import SwPanelGroup from './sw-panel-group.vue';
import {
  ProvidedPanelParam,
  PanelSummaryConfig,
  PanelBulletConfig,
} from './types';

/**
 * @event request-toggle-change `(toggled: boolean)`
 */
@Component({
  components:{
    SwIcon,
    SwToggle,
    SwStatusFlag,
    SwTransitionExpand,
  },
})
export default class SwPanel extends SwExtendedVue{
  // props
  @Prop({ type: String, required: true })
  panelId: string;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: Object, default: null })
  summaryConfig: PanelSummaryConfig | null;

  @Prop({ type: Array, default: null })
  panelBullets: PanelBulletConfig[] | null;

  @Inject()
  panelParam: ProvidedPanelParam;

  // data
  cssPrefix: string = 'sw-panel';

  // computed
  get isExpanded(): boolean {
    return this.panelParam.expandedPanels.findIndex(e => (e === this.panelId)) >= 0;
  }

  get theme(): string {
    return this.panelParam.theme;
  }

  get toggleName(): string {
    return `__panel-toggle-${Math.floor(Math.random() * 100000000)}`;
  }

  // methods
  @Inject()
  claimPanelExpanded: SwPanelGroup['claimPanelExpanded'];

  onHeaderClick() {
    this.claimPanelExpanded(this.panelId, !this.isExpanded);
  }

  handleToggleChange(value: boolean, ev:Event) {
    ev.stopPropagation();
    this.$emit('request-toggle-change', value);
  }
}
